import { mutationTypes } from '@/core/constants'
import paginacaoListagem from "@/core/store/default/paginacaoListagem";

function buscarItemSelecionado(item, array, keys) {
	const index = array.findIndex(
		(el) => el[keys.PROCESSO] === item.idProcesso && el[keys.FORNECEDOR] === item.idFornecedor,
	)
	if (indexEhValido(index)) {
		const posEdital = array[index][keys.EDITAIS].findIndex((value) => value.numeroEdital === item.numeroEdital)

		if (indexEhValido(posEdital)) {
			const isUnico = array[index][keys.EDITAIS].length === 1
			return { index: index, posEdital: posEdital, isUnico: isUnico }
		} else {
			return { index: index, posEdital: null, isUnico: null }
		}
	}

	return null
}

function addItemSelecionado(item, array) {
	const keys = montarKeysDeItemSelecionado()

	if (array.length === 0) {
		array.push(montarItemSelecionado(item))
	} else {
		const index = buscarItemSelecionado(item, array, keys)

		if (typeof index === 'number') {
			const numeroEdital = item.numeroEdital
			const idLotes = item.idLotes

			array[index][keys.EDITAIS].push(montarEditalItem(numeroEdital, idLotes))
		} else {
			array.push(montarItemSelecionado(item))
		}
	}
}

function deleteItemSelecionado(item, array) {
	const keys = montarKeysDeItemSelecionado()
	const obj = buscarItemSelecionado(item, array, keys)

	if (obj !== null) {
		const { index, posEdital, isUnico } = obj

		if (isUnico) {
			array.splice(index, 1)
		} else {
			array[index][keys.EDITAIS].splice(posEdital, 1)
		}
	}
}

function montarEditalItem(numeroEdital, idLotes) {
	return {
		numeroEdital: numeroEdital,
		lotes: idLotes,
	}
}

function montarItemSelecionado(item) {
	return {
		documento: item.documento,
		razaoSocial: item.razaoSocial,
		idProcesso: item.idProcesso,
		idFornecedor: item.idFornecedor,
		editais: [
			{
				numeroEdital: item.numeroEdital,
				lotes: item.idLotes,
			},
		],
		idItensNaoAdicionados: item.idItensNaoAdicionados,
		selecionado: item.selecionado,
	}
}

function montarKeysDeItemSelecionado() {
	return {
		PROCESSO: 'idProcesso',
		FORNECEDOR: 'idFornecedor',
		EDITAIS: 'editais',
		LOTES: 'lotes',
	}
}

function indexEhValido(index) {
	return index !== -1
}

export default {
	[mutationTypes.ITEM_ATA.SET_FILTRO_LISTAGEM](state, filtro) {
		state.filtro = filtro
	},

	[mutationTypes.ITEM_ATA.SET_PAGINACAO_LISTAGEM](state, paginacao) {
		state.paginacao = paginacao
	},

	[mutationTypes.ITEM_ATA.RESETAR_PAGINA_LISTAGEM](state) {
		state.paginacao.page = 1
	},
	[mutationTypes.ITEM_ATA.RESET_PAGINACAO_LISTAGEM](state) {
		state.paginacao = paginacaoListagem(['item'])
	},
	[mutationTypes.ITEM_ATA.SET_ITENS_ARRAY_PARA_ADICIONAR](state, array) {
		state.itensParaAdicionarNaAta = array
	},

	[mutationTypes.ITEM_ATA.ITEM_ATA_SELECIONADO](state, itens) {
		state.itensAtaSelecionados = itens
	},

	[mutationTypes.ITEM_ATA.SET_ITENS_PARA_ADICIONAR](state, item) {
		if (item) {
			let itemExistente = state.itensParaAdicionarNaAta.filter(
				(sel) =>
					sel.idProcesso === item.idProcesso &&
					sel.idFornecedor === item.idFornecedor &&
					sel.numeroEdital === item.numeroEdital,
			)

			if (item.selecionado) {
				if (itemExistente.length === 0) {
					state.itensParaAdicionarNaAta.push(item)
				}
			} else {
				state.itensParaAdicionarNaAta.splice(state.itensParaAdicionarNaAta.indexOf(itemExistente), 1)
			}
		}
	},

	[mutationTypes.ITEM_ATA.GERAR_ATA_COM_PROCESSO.SET_ITENS_SELECIONADOS](state, item) {
		if (item.selecionado) {
			addItemSelecionado(item, state.itensParaAdicionarNaAta)
		} else {
			deleteItemSelecionado(item, state.itensParaAdicionarNaAta)
		}
	},

	[mutationTypes.ITEM_ATA.SET_FILTRO_ITENS_IGNORADOS](state, parametros) {
		let { itemIgnorado, item } = parametros

		let selecionado = state.itensParaAdicionarNaAta.filter((sel) => {
			return (
				sel.idProcesso === item.idProcesso &&
				sel.idFornecedor === item.idFornecedor &&
				sel.numeroEdital === item.numeroEdital
			)
		})[0]
		if (itemIgnorado.selecionado && selecionado) {
			selecionado.idItensNaoAdicionados.push(itemIgnorado)
		} else {
			selecionado.idItensNaoAdicionados.splice(selecionado.idItensNaoAdicionados.indexOf(itemIgnorado), 1)
		}
	},

	[mutationTypes.ITEM_ATA.LIMPAR_ITENS_PARA_ADICIONAR](state) {
		state.itensParaAdicionarNaAta = []
	},

	[mutationTypes.ITEM_ATA.RESET_ITENS_ATA_SELECIONADOS](state) {
		state.itensAtaSelecionados = []
	},

	[mutationTypes.ITEM_ATA.SET_ITEM_SELECIONADO](state, item) {
		state.itemSelecionado = item
	},

	[mutationTypes.ITEM_ATA.ITEM_PARA_EXCLUIR](state, itens) {
		state.itensParaExcluir = itens
	},

	[mutationTypes.ITEM_ATA.SET_IS_SELECIONOU_TODOS_ITENS](state) {
		state.isSelecionouTodosItensDaAta = true
	},

	[mutationTypes.ITEM_ATA.UNSET_IS_SELECIONOU_TODOS_ITENS](state) {
		state.isSelecionouTodosItensDaAta = false
	},

	[mutationTypes.ITEM_ATA.SET_HISTORICOS](state, existeHistorico) {
		state.existeHistorico = existeHistorico
	},
	[mutationTypes.ITEM_ATA.SET_HISTORICO_ALTERAR_CLASSIFICACAO](state, existeHistorico) {
		state.existeHistorico.acessoHistoricoAlterarClassificacao = existeHistorico
	},
	[mutationTypes.ITEM_ATA.SET_HISTORICO_ALTERAR_FORNECEDOR](state, existeHistorico) {
		state.existeHistorico.acessoHistoricoAlterarFornecedor = existeHistorico
	},
	[mutationTypes.ITEM_ATA.SET_HISTORICO_GERENCIAR_SALDO](state, existeHistorico) {
		state.existeHistorico.acessoHistoricoGerenciarSaldo = existeHistorico
	},
	[mutationTypes.ITEM_ATA.LIMPAR_HISTORICOS](state) {
		state.existeHistorico = {
			acessoHistoricoRealinhar: false,
			acessoHistoricoBloquearDesbloquear: false,
			acessoHistoricoAlterarClassificacao: false,
			acessoHistoricoAlterarFornecedor: false,
			acessoHistoricoGerenciarSaldo: false,
		}
	},
}
